import React, { useEffect } from 'react';
import './main-dashboard.scss';
import TaskDashboard from './tasks-dashboard/taskdashboard';
import ActivityDashboard from './activity-dashboard/ActivityDashboard';
import { Column, Row } from '../components';
import { Container } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { resetCustomerSliderState } from '../customer/customer-slider-content/CustomerSliderContext';
import { setCustomerSummary, storeCustomerPolicies, updateCustomers, updateSelectedPolicyDetails } from '../customer/customer-slice/Customer-slice';
import { updateNoteList } from '../customer/customer-slice/Customer-note-slice';

export interface IMainDashboard {
    navigateTo : (path : string) => void
}

const MainDashboard : React.FunctionComponent<IMainDashboard> = (props) => {

        const dispatch = useDispatch()
    
    
        const clearCustomerRelatedDataFromStore = () => {
                dispatch(resetCustomerSliderState());
                dispatch(updateCustomers({}));
                dispatch(storeCustomerPolicies([]));
                dispatch(updateSelectedPolicyDetails({ policyId: '', polEventId: '', policyDetails: null }));
                dispatch(updateNoteList([]));
                dispatch(setCustomerSummary(null));
                // if(isPinnedLocalStorage == null || isPinnedLocalStorage == undefined || isPinnedLocalStorage == 'false') {
                // sliderContext.hideSlider();
                // }else{
                // sliderContext.showSlider();
                // sliderContext.pinSlider();
                // }
            }
    
        useEffect(() => {
            clearCustomerRelatedDataFromStore();
        }, []);

    return (
        <div className='bg-light pt-5'>
            <Container fluid>
                <Row>
                    <Column lg={6} md={6}>
                        <TaskDashboard navigateTo={props.navigateTo}></TaskDashboard>
                    </Column>
                    <Column lg={6} md={6}>
                        <ActivityDashboard navigateTo={props.navigateTo}></ActivityDashboard>
                    </Column>
                </Row>
            </Container>

        </div>
    )
}

export default MainDashboard